export const componentDecorator = (href: string, text: string) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="underline">
    {text}
  </a>
)
